import { IChipOption } from 'components/ChipSelect';
import { UserLookupWrapper } from 'components/Lookups/UserLookups/UserLookupWrapper';
import React from 'react';
import { LookupChipSelect } from '../LookupChipSelect';

interface IProps {
  includeDeleted?: boolean;
  includeInactive?: boolean;
  selectedIds?: number[];
  firstPeriodId?: number | null;
  lastPeriodId?: number | null;
  onChange: (selectedOptions: readonly IChipOption[]) => void;
  placeholder?: string;
}

export const UserChipSelect = (props: IProps): JSX.Element => {
  return (
    <UserLookupWrapper
      includeDeleted={props.includeDeleted}
      includeInactive={props.includeInactive}
      firstPeriodId={props.firstPeriodId}
      lastPeriodId={props.lastPeriodId}
    >
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupChipSelect
          extractLookups={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          onChange={props.onChange}
          selectedIds={props.selectedIds}
          placeholder={props.placeholder}
        />
      )}
    </UserLookupWrapper>
  );
};
